import * as R from "ramda";
import { Card } from "antd";
import React, { Fragment } from "react";

import { SingleTemplateCard } from "@/containers/Video/tab-pages/video-template-job";

export const SelectedCard = (props) => {
  const active = R.pathOr(false, ["active"], props);
  return (
    <Card {...props}>
      <div
        style={{
          //  添加一个右上角选中的样式, 三角, 边角圆润
          position: "absolute",
          right: 2,
          top: 2,
          width: 0,
          height: 0,
          borderLeft: "15px solid transparent",
          borderBottom: "15px solid transparent",
          borderRight: "15px solid #f50",
          borderTop: "15px solid #f50",
          display: active ? "block" : "none",
        }}
      ></div>
      {props.children}
    </Card>
  );
};

export const SelectedCardList = (props) => {
  const selectedRowKeys = R.pathOr([], ["selectedRowKeys"], props);
  const setSelectedRowKeys = R.pathOr(R.T, ["setSelectedRowKeys"], props);
  const rowKey = R.pathOr("id", ["rowKey"], props);
  const dataSource = R.pathOr([], ["dataSource"], props);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        margin: 16,
      }}
    >
      {dataSource.map((item) => {
        const key = R.prop(rowKey, item);
        return (
          <Fragment key={key}>
            <SingleTemplateCard
              model={props.model}
              detail={item}
              rowKey={rowKey}
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              {...R.omit(["dataSource"], props)}
            />
          </Fragment>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/selected-card-list.js